import { lazy } from 'react'
import { getLinkObject } from '../../services/getLinkObject'

export const AGENT_LINKS = {
  PROFILES: getLinkObject(
    '/agent/profiles',
    'Profiles',
    lazy(() => import('./pages/profiles/Profiles'))
  ),
  SETTINGS: getLinkObject(
    '/agent/settings',
    'Settings',
    lazy(() => import('./pages/settings/Settings'))
  )
}

export const PERSON_ID_MAX_LENGTH = 50

export const PROFILE_FORM_KEYS = {
  PROFILE_ID: 'profileId',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  AUDIO: 'audio',
  PHOTO: 'photo'
}
